import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[appNumericOnly]',
  standalone: false,
})
export class NumericOnlyDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    private control: NgControl
  ) {}

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const inputElement = this.el.nativeElement;
    const initialValue = inputElement.value;

    const sanitizedValue = initialValue.replace(/[^0-9]/g, '');
    inputElement.value = sanitizedValue;

    if (initialValue !== sanitizedValue) {
      event.stopPropagation();
    }

    this.control?.control?.setValue(
      sanitizedValue === '' ? null : sanitizedValue,
      { emitEvent: false }
    );
  }

  @HostListener('blur') onBlur() {
    const inputElement = this.el.nativeElement;
    let value = inputElement.value;

    if (value === '' || value == null) {
      value = '0';
      inputElement.value = value;
      this.control?.control?.setValue(value, { emitEvent: false });
    }
  }
}
